import React, { createContext, useContext, useState } from 'react';
import { CircularProgress, Backdrop, Typography, Box } from '@mui/material';

// Create the context
const LoaderContext = createContext();

// Custom hook to use the loader context
export const useLoader = () => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error('useLoader must be used within a LoaderProvider');
  }
  return context;
};

// Loader Provider component
export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('Loading...');

  const showLoader = (customMessage) => {
    setMessage(customMessage || 'Loading...');
    setLoading(true);
  };

  const hideLoader = () => {
    setLoading(false);
  };

  const value = {
    showLoader,
    hideLoader,
  };

  return (
    <LoaderContext.Provider value={value}>
      {children}
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          flexDirection: 'column',
        }}
        open={loading}
      >
        <Box sx={{ position: 'relative', width: '80px', height: '80px' }}>
          <Box sx={{ p: 3, display: 'flex', justifyContent: 'center' }}>
            <CircularProgress />
          </Box>
        </Box>
      </Backdrop>
    </LoaderContext.Provider>
  );
};

export default LoaderProvider;
